const toComparableText = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return String(value);
  return "";
};

export const compareTextAsc = (a: unknown, b: unknown): number =>
  toComparableText(a).localeCompare(toComparableText(b), "pt-BR", { sensitivity: "base" });
